/*
 * mh-qty-picker.js — m2/Stueck-Umrechner (FoxTheme/Hyper / myHarry) — v7
 *
 * v7-FIX (Preisberechnung): Der Picker spiegelt jetzt den PDP-Preisblock.
 *   - Ist der BIRTHDAY/BD-Coupon aktiv, nutzt er DESSEN Preis (Preis) und Sonderpreis je Stueck
 *     (gleiche Basis & gleicher Rabatt-% wie oben), statt compare_at_price gegen price zu rechnen.
 *   - Ohne aktiven Coupon: regulaerer Shopify-Sale (compare_at_price -> price) wie bisher.
 *   Dadurch passt der Streichpreis-zu-Sonderpreis-Rabatt im Mengenrechner zum angezeigten Produktpreis.
 *
 * Bestehender v6-Hinweis (FB-Pixel/Einfrieren) bleibt gueltig:
 *   Anzeige-Texte werden per nodeValue (characterData) aktualisiert, der Picker liegt ausserhalb des <form>.
 */
(function () {
  var VERSION = 'v7';
  try { console.log('[mh-qty-picker] ' + VERSION + ' script loaded'); } catch (e) {}

  window.__mhPickers = window.__mhPickers || [];

  function fmtMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + '€';
  }

  // Geld-String (z. B. "1.234,56 €") -> Cents. Deutsche Notation: Tausender '.', Dezimal ','.
  function parseMoneyCents(el) {
    if (!el) return null;
    var t = (el.textContent || '').replace(/[^0-9.,]/g, '');
    if (!t) return null;
    if (t.indexOf(',') > -1) { t = t.replace(/\./g, '').replace(',', '.'); }
    var n = parseFloat(t);
    return isNaN(n) ? null : Math.round(n * 100);
  }

  // Aktiver BD-Coupon (BIRTHDAY) Preisblock der PDP -> Preis & Sonderpreis je Stueck (Cents) oder null.
  function getBdCouponPerPiece() {
    var c = document.querySelector('.price__container-with-coupon');
    if (!c || c.classList.contains('d-none')) return null;
    var reg = parseMoneyCents(c.querySelector('.price--wrapper .value'));
    var spc = parseMoneyCents(c.querySelector('.discount-price--wrapper .value'));
    if (reg == null || spc == null) return null;
    return { regular: reg, special: spc };
  }

  // characterData-Update statt textContent-Ersatz (kein childList -> fuer FB-Pixel unsichtbar).
  function ensureTextNode(el) {
    if (!el) return null;
    var n = el.firstChild;
    if (!n || n.nodeType !== 3) {
      while (el.firstChild) el.removeChild(el.firstChild);
      n = document.createTextNode('');
      el.appendChild(n);
    }
    return n;
  }
  function setText(el, txt) {
    var n = ensureTextNode(el);
    if (n && n.nodeValue !== txt) n.nodeValue = txt;
  }
  function setVal(el, val) { if (el && String(el.value) !== String(val)) el.value = val; }
  function setHidden(el, h) { if (el && el.hidden !== h) el.hidden = h; }
  function setClass(el, cls, on) { if (el) el.classList.toggle(cls, on); }

  function initPicker(root) {
    if (!root || root.__mhInit) return;
    root.__mhInit = true;
    try { console.log('[mh-qty-picker] ' + VERSION + ' init', root.dataset.sectionId || ''); } catch (e) {}

    var state = { mode: 'm2' };
    var formId = root.dataset.formId;
    var fallbackVariantId = root.dataset.variantId;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-mh-variant-data]').textContent); } catch (e) { data = {}; }

    var input = root.querySelector('.mh-qty-picker__input');
    var unitEl = root.querySelector('[data-mh-unit]');
    var modeBtns = root.querySelectorAll('[data-mh-mode]');
    var stepBtns = root.querySelectorAll('[data-mh-step]');
    var resultStueck = root.querySelector('[data-mh-result-stueck]');
    var line1Price = root.querySelector('[data-mh-line1-price]');
    var specialWrap = root.querySelector('[data-mh-special-wrap]');
    var resultPrice = root.querySelector('[data-mh-result-price]');
    var realQty = root.querySelector('[data-mh-real-qty]');
    if (!input || !realQty || !resultStueck) return;

    ensureTextNode(resultStueck);
    ensureTextNode(line1Price);
    ensureTextNode(unitEl);
    ensureTextNode(resultPrice);

    try {
      var formEl = formId ? document.getElementById(formId) : root.closest('form');
      var wrap = root.closest('.mh-qty-wrap') || root;
      if (formEl && formEl.parentNode && formEl.contains(wrap)) {
        if (realQty && formId && !realQty.getAttribute('form')) realQty.setAttribute('form', formId);
        formEl.parentNode.insertBefore(wrap, formEl);
      }
    } catch (e) {}

    function idInput() {
      return (formId && document.querySelector('#' + CSS.escape(formId) + ' input[name="id"]')) ||
        document.querySelector('input[name="id"].product-variant-id');
    }
    function currentVariantId() {
      var el = idInput();
      if (el && el.value) return String(el.value);
      return String(fallbackVariantId);
    }
    function variantData() {
      return data[currentVariantId()] || data[Object.keys(data)[0]] ||
        { qpsm: 0, price: 0, compareAtPrice: null, batch: 1 };
    }
    function getBatch() { return Math.max(1, parseInt(variantData().batch, 10) || 1); }
    function parseNum(val) { var n = parseFloat(String(val).replace(',', '.')); return isNaN(n) ? 0 : n; }

    function recalc() {
      try {
        var d = variantData();
        var batch = Math.max(1, parseInt(d.batch, 10) || 1);
        var qpsm = parseFloat(d.qpsm) || 0;
        var raw = parseNum(input.value);
        if (raw < 0) raw = 0;
        var stueck = state.mode === 'm2' ? Math.ceil((raw * qpsm) - 0.02) : Math.round(raw);
        if (stueck < 1) stueck = batch;
        if (batch > 1) stueck = Math.ceil(stueck / batch) * batch;
        if (state.mode === 'm2' && qpsm > 0 && document.activeElement !== input) {
          setVal(input, Math.round((stueck / qpsm) * 100) / 100);
        }

        setVal(realQty, stueck);
        setText(resultStueck, '= ' + stueck + ' Stück');

        var price = Number(d.price) || 0;
        var compareAt = d.compareAtPrice == null ? null : Number(d.compareAtPrice);

        // Preis-Basis: aktiver BIRTHDAY-Coupon hat Vorrang (identische Werte wie der PDP-Preisblock),
        // sonst regulaerer Shopify-Sale (compare_at_price -> price).
        var bd = getBdCouponPerPiece();
        var struckPP, specialPP, onSale;
        if (bd) {
          struckPP = bd.regular;
          specialPP = bd.special;
          onSale = bd.special < bd.regular;
        } else if (compareAt != null && compareAt > price) {
          struckPP = compareAt;
          specialPP = price;
          onSale = true;
        } else {
          struckPP = price;
          specialPP = price;
          onSale = false;
        }

        var total = stueck * specialPP;
        if (onSale) {
          setText(line1Price, fmtMoney(stueck * struckPP));
          setClass(line1Price, 'is-strike', true);
          setText(resultPrice, fmtMoney(total));
          setHidden(specialWrap, false);
        } else {
          setText(line1Price, fmtMoney(total));
          setClass(line1Price, 'is-strike', false);
          setHidden(specialWrap, true);
        }
      } catch (e) { try { console.error('[mh-qty-picker] recalc', e); } catch (x) {} }
    }

    function setMode(mode) {
      try {
        if (mode === state.mode) return;
        state.mode = mode;
        modeBtns.forEach(function (b) {
          var active = b.dataset.mhMode === mode;
          setClass(b, 'is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        setText(unitEl, mode === 'm2' ? 'm²' : 'Stück');
        if (mode === 'stk') {
          setVal(input, getBatch());
        } else {
          var dM = variantData();
          var qpsmM = parseFloat(dM.qpsm) || 0;
          var batchM = Math.max(1, parseInt(dM.batch, 10) || 1);
          setVal(input, qpsmM > 0 ? Math.round((batchM / qpsmM) * 100) / 100 : 1);
        }
        recalc();
      } catch (e) { try { console.error('[mh-qty-picker] setMode', e); } catch (x) {} }
    }

    function step(dir) {
      try {
        var dStep = variantData();
        var batch = Math.max(1, parseInt(dStep.batch, 10) || 1);
        var qpsmStep = parseFloat(dStep.qpsm) || 0;
        var unitM2 = qpsmStep > 0 ? (batch / qpsmStep) : 1;
        var stepSize = state.mode === 'stk' ? batch : unitM2;
        var min = stepSize;
        var v = parseNum(input.value);
        if (v <= 0) v = min;
        v = v + dir * stepSize;
        if (v < min) v = min;
        v = Math.round(v * 100) / 100;
        setVal(input, v);
        recalc();
      } catch (e) { try { console.error('[mh-qty-picker] step', e); } catch (x) {} }
    }

    function snapOnChange() {
      try {
        if (state.mode === 'stk') {
          var batch = getBatch();
          var v = Math.round(parseNum(input.value));
          if (v < batch) v = batch;
          if (batch > 1) v = Math.ceil(v / batch) * batch;
          setVal(input, v);
        } else {
          var dS = variantData();
          var qpsmS = parseFloat(dS.qpsm) || 0;
          var batchS = Math.max(1, parseInt(dS.batch, 10) || 1);
          var unitS = qpsmS > 0 ? (batchS / qpsmS) : 1;
          var rawS = parseNum(input.value);
          if (rawS < unitS) rawS = unitS;
          if (qpsmS > 0) {
            var st = Math.ceil((rawS * qpsmS) - 0.02);
            if (st < 1) st = batchS;
            if (batchS > 1) st = Math.ceil(st / batchS) * batchS;
            setVal(input, Math.round((st / qpsmS) * 100) / 100);
          } else {
            setVal(input, rawS);
          }
        }
        recalc();
      } catch (e) { try { console.error('[mh-qty-picker] snap', e); } catch (x) {} }
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); setMode(e.currentTarget.dataset.mhMode); });
    });
    stepBtns.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); step(parseInt(e.currentTarget.dataset.mhStep, 10) || 0); });
    });
    input.addEventListener('input', recalc);
    input.addEventListener('change', snapOnChange);

    window.__mhPickers.push({ root: root, recalc: recalc });
    recalc();
  }

  function recalcAll() {
    window.__mhPickers = window.__mhPickers.filter(function (p) { return document.contains(p.root); });
    window.__mhPickers.forEach(function (p) { try { p.recalc(); } catch (e) {} });
  }

  function initAll(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    try { scope.querySelectorAll('[data-mh-picker]').forEach(initPicker); } catch (e) {}
  }

  // Globale Listener NUR EINMAL binden
  if (!window.__mhPickerGlobalBound) {
    window.__mhPickerGlobalBound = true;
    ['variant:change', 'variant:changed'].forEach(function (evt) {
      document.addEventListener(evt, recalcAll);
    });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); recalcAll(); });
    document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      try { FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, recalcAll); } catch (e) {}
    }

    // BD-Coupon (BIRTHDAY) befuellt den PDP-Preisblock asynchron (nach /cart.js).
    // Sobald sich dieser Block aendert/ein-/ausblendet, Picker neu berechnen.
    try {
      if (window.MutationObserver) {
        var bindBdObserver = function () {
          var bdContainers = document.querySelectorAll('.price__container-with-coupon');
          if (!bdContainers.length) return;
          var bdObs = new MutationObserver(function () {
            clearTimeout(window.__mhBdRecalcT);
            window.__mhBdRecalcT = setTimeout(recalcAll, 60);
          });
          bdContainers.forEach(function (c) {
            bdObs.observe(c, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
          });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', bindBdObserver);
        } else { bindBdObserver(); }
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
})();
